// extracted by mini-css-extract-plugin
export default {"btnContainer":"GeneratePDF_btnContainer__xSqlP","inner":"GeneratePDF_inner__Ne12G"};